import { useTranslation } from 'react-i18next';
import type { MarketSetting } from '@/mocks/dashboard';

interface Props {
  settings: MarketSetting;
}

export default function DashboardMarket({ settings }: Props) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="rounded-xl border border-ink-100 bg-white">
      <div className="flex items-center justify-between px-4 md:px-5 py-3 md:py-4 border-b border-ink-100">
        <div className="flex items-center gap-2">
          <i className="ri-settings-3-line text-warm-400 text-lg" />
          <h3 className="text-sm md:text-base font-semibold text-ink-600">{t('dashboard.market.title')}</h3>
        </div>
      </div>

      <div className="px-4 md:px-5 py-4 md:py-5 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-xs text-ink-300">{t('dashboard.market.country')}</span>
          <span className="text-sm font-medium text-ink-600">{settings.country}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-ink-300">{t('dashboard.market.language')}</span>
          <span className="text-sm font-medium text-ink-600">{settings.language}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-ink-300">{t('dashboard.market.displayCurrency')}</span>
          <span className="text-sm font-medium text-ink-600">{settings.displayCurrency}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-ink-300">{t('dashboard.market.quoteBase')}</span>
          <span className="text-sm font-medium text-ink-600">{settings.quoteBaseCurrency}</span>
        </div>
        {settings.exchangeRateDate && (
          <div className="flex items-center justify-between">
            <span className="text-xs text-ink-300">{t('dashboard.market.exchangeRate')}</span>
            <span className="text-xs font-mono text-ink-400">{settings.exchangeRateDate}</span>
          </div>
        )}

        <a
          href="/my/settings"
          className="inline-flex items-center justify-center w-full text-xs md:text-sm font-medium px-3 py-2 rounded-lg border border-ink-200 text-ink-500 hover:bg-cream-100 transition-colors whitespace-nowrap mt-1"
        >
          {t('dashboard.market.change')}
        </a>
      </div>
    </div>
  );
}